import { createSelector } from 'reselect'

const getCredentialsRecoveryState = state => state.corporateCredentialsRecovery

export const isFetchingCredentialRecovery = createSelector(
  getCredentialsRecoveryState,
  requestState => (requestState ? requestState.isFetching : null)
)
export const getCredentialRecoveryError = createSelector(
  getCredentialsRecoveryState,
  requestState => (requestState ? requestState.error : null)
)
export const getCredentialRecoverySuccess = createSelector(
  getCredentialsRecoveryState,
  requestState => (requestState ? requestState.data : null)
)
